<template>
  <div id="page-wrap" v-if="loggedIn">
    <div class="container content-wrapper">
      <div class="row">
        <form class="prepaid-form" @submit.prevent="proceedToPlan">
          <DropDown
            @on-change="selectOperator"
            title="Select Operator"
            valueName="operator"
            :items="operators"
            @keypress="isNumber($event)"
          />

          <input
            class="account-id__input"
            type="number"
            placeholder="Subscriber ID"
            v-model="recharge_account_id"
            v-numericOnly
          />
          <p class="input-error-text">{{ validationTextMobile }}</p>
          <p class="error-text">{{ pageError }}</p>
          <ActionButton title="Continue" :disabled="!(recharge_account_id.length > 0 && operator)" />
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";
import DropDown from "@/components/DropDown/index";
export default {
  name: "DTH",
  data() {
    return {
      pageError: "",
      validationTextMobile: "",
      validMobile: false
    };
  },
  components: { ActionButton, DropDown },
  computed: {
    ...mapGetters([
      "operators",
      "regions",
      "loggedIn",
      "operator",
      "valid_recharge_account_id"
    ]),
    recharge_account_id: {
      get() {
        return this.$store.state.recharge.recharge_account_id;
      },
      set(value) {
        return this.$store.commit("set_recharge_account_id", value);
      }
    }
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "BILL_PAYMENT_SELECTED",
      propertyName: "BILL_TYPE",
      propertyValue: "DTH"
    });
    this.$store.dispatch("setRechargeAccountId", "");
    this.$store
      .dispatch("getOperatorsAndRegions", this.$route.name)
      .then(resp => {
        this.operatorsLoaded = true;
      });
  },
  methods: {
    validateMobileNumber(getInput) {
      var mobileNumber = getInput.target.value;
      this.$store.dispatch("setRechargeAccountId", mobileNumber);
      // console.log(mobileNumber)
      var regexMobile = /^\d{10}$/;
      this.validMobile = regexMobile.test(mobileNumber);
      let mobileFirstDigit = mobileNumber.charAt(0);
      // console.log(this.validMobile)
      if (mobileFirstDigit == 0) {
        this.validMobile = false;
        this.validationTextMobile = "Enter a Valid Card Number";
      } else {
        if (this.validMobile) {
          this.validationTextMobile = "";
          this.$store.dispatch("setRechargeAccountId", mobileNumber);
        } else {
          this.validationTextMobile = "Enter a Valid Card Number";
          // this.$store.dispatch("setValidRechargeAccountId");
        }
      }
    },
    selectOperator(getInput) {
      var getOperator = getInput.target.value;
      this.$store.dispatch("setRechargeOperator", getOperator);
    },
    selectRegion(getInput) {
      var getRegion = getInput.target.value;
      this.$store.dispatch("setRechargeRegion", getRegion);
    },
    proceedToPlan() {
      this.pageError = "";
      if (this.valid_recharge_account_id && this.operator) {
        this.$store.dispatch("selectPlan", {
          amount: "",
          description: ""
        });
        this.$router.push({
          name: "ChoosePlan",
          params: { type: "DTH" },
          query: this.$route.query
        });
      } else {
        this.pageError = "Please fill all the field.";
      }
    },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.account-id {
  &__input {
    font-size: 20px;
    padding: 8px 16px;
    &::placeholder {
      font-size: 16px;
      color: #d6d4d4;
    }
    width: 100%;
    border-radius: 3px;
    border: solid 0.5px #d4d4d4;
    background-color: #ffffff;
    margin-top: 24px;
    &:focus {
      outline: #3482fd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DTH.vue